var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class NameAndNationalIdCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        this.fullName = checkpoint.fullName;
        this.nationalId = checkpoint.nationalId;
    }
    toJson() {
        return {
            fullName: this.fullName,
            nationalId: this.nationalId,
            type: this.type,
            comment: this.comment,
            discrepancy: this.discrepancy,
            researcherId: this.researcherId,
            verificationDate: this.calculateVerificationDate()
        };
    }
}
__decorate([
    observable
], NameAndNationalIdCheckpoint.prototype, "fullName", void 0);
__decorate([
    observable
], NameAndNationalIdCheckpoint.prototype, "nationalId", void 0);
__decorate([
    action
], NameAndNationalIdCheckpoint.prototype, "toJson", null);
